export const getColumnClasses = (column, horizontalScroll) => {
  if (horizontalScroll) return '';

  const classes = [`accordion-col-${column.width}`];

  if (column.responsive) {
    if (column.responsive.large) {
      classes.push(`accordion-col-lg-${column.responsive.large}`);
    }
    if (column.responsive.xlarge) {
      classes.push(`accordion-col-xl-${column.responsive.xlarge}`);
    }
  }

  return classes.join(' ');
};

export const getColumnStyle = (column, horizontalScroll) => {
  if (horizontalScroll) {
    return {minWidth: `${column.width * 5}rem`};
  }
  return {};
};
